import { useCallback, useEffect, useState, Fragment } from "react";
import { Grid, Button, IconButton } from "@mui/material";
import { StyledLink } from "components/shared/Link";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { StyledStack, StyledTitle } from "./AddCategory.style";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import CategoryCard from "components/category";
import { getCategoryRequest } from "api/requests";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import { PAGINATION_LIMIT } from "constants";
import PaginationCM from "components/shared/Pagination";
import TableCM from "components/shared/Table";
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import GenarateHeadCell from "helper/generate-head-cell";

const headCells = GenarateHeadCell("category");

export default function Category() {
  const navigate = useNavigate();
  const [category, setCategory] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(1);

  const handelSearch = (e) => getCategory(e);

  const getCategory = useCallback(
    async (search) => {
      const res = await request({
        url: getCategoryRequest,
        values: {
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
          limit: search ? 100 : PAGINATION_LIMIT,
          search,
        },
      });

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        type: items.type,
        design: (
          <Link to={`/design/add/${items.id}`}>
            <IconButton color="primary">
              <DesignServicesIcon />
            </IconButton>
          </Link>
        ),
        edit: (
          <Link to={`/category/${items.id}`}>
            <IconButton color="primary">
              <EditIcon />
            </IconButton>
          </Link>
        ),
      }));

      setCategory({ data: transformedData, count: res.count });
    },
    [page, request]
  );

  useEffect(() => {
    getCategory();
  }, [page, getCategory]);

  return (
    <DrawerCM title="زیردسته ها" onSearch={handelSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={1}>
          <Grid item xs={12} my={2}>
            <TableCM
              title="زیردسته ها"
              rows={category.data}
              headCells={headCells}
              page={page}
              addCategory
            />
          </Grid>
          {category.data.length > 0 ? (
            <PaginationCM
              handleChange={(e, val) => setPage(val)}
              page={page}
              count={category.count}
            />
          ) : (
            " "
          )}
        </Grid>
      )}
    </DrawerCM>
  );
}
